import React from 'react'
import { CurrencyFormat, DateFormat } from '../../../helpers/formatting'
import { sortData, handleSort } from './chirpResultsHelpers'
import SortableColumnHeader from './SortableColumnHeader'
import CollapsibleTableSection from './CollapsibleTableSection'

const COLUMNS = [
  { column: 'date', label: 'Date' },
  { column: 'description', label: 'Description' },
  { column: 'amount', label: 'Amount' },
  { column: 'category', label: 'Category' },
  { column: 'status', label: 'Status' },
]

const TransactionHistoryTable = ({ data, expanded, onToggle, sortState, setSortState }) => (
  <CollapsibleTableSection
    title={`Transaction History (${data.length} transactions)`}
    expanded={expanded}
    onToggle={onToggle}
  >
    <div className="list-table-container lox-scroll-400">
      <table className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead className="is-sticky lox-sticky-header">
          <tr className="is-selected">
            {COLUMNS.map(({ column, label }) => (
              <SortableColumnHeader
                key={column}
                label={label}
                column={column}
                sortState={sortState}
                onSort={() => handleSort(setSortState, column)}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {sortData(data, sortState.column, sortState.direction).map((transaction) => (
            <tr key={transaction.key}>
              <td className="has-text-centered is-nowrap">{DateFormat({ dateString: transaction.date })}</td>
              <td className="has-text-centered">{transaction.description}</td>
              <td className={`has-text-centered ${transaction.amount >= 0 ? 'has-text-success' : 'has-text-danger'} is-nowrap`}>
                {CurrencyFormat({ value: transaction.amount })}
              </td>
              <td className="has-text-centered is-nowrap">
                <span className="tag is-light">{transaction.category}</span>
              </td>
              <td className="has-text-centered is-nowrap">
                <span className={`tag ${transaction.status === 'POSTED' ? 'is-success' : 'is-warning'}`}>
                  {transaction.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </CollapsibleTableSection>
)

export default TransactionHistoryTable
